import { useEffect, useRef, useState } from "react";
import FlexRow from "../../../../../components/base/FlexRow";
import Modal from "../../../../../components/base/Modal";
import { DrawerForm, DrawerFormRef } from "../../../../../components/drawers/DrawerForm";
import DatePicker from "../../../../../components/form/DatePicker";
import TimePicker, { TimeItem } from "../../../../../components/form/TimePicker";
import { API_ROUTES } from "../../../../../core/Constants";
import { toJobDate, useHub, usePreferences } from "../../../../../core/Global";
import Job, { JobApptReminderItem } from "../../models/Job"
import DropDown from "../../../../../components/form/DropDown";
import TextArea from "../../../../../components/form/TextArea";
import JobStatus from "../../../base/models/JobStatus";
import ToggleSwitch from "../../../../../components/form/ToggleSwitch";
import TextBox from "../../../../../components/form/TextBox";
import Icon from "../../../../../components/base/Icon";
import moment from "moment";


interface IProps {
    job: Job
    forceUpdateStatus?: boolean
    onUpdate?: () => void
    onClose?: () => void
    onCancel?: () => void
}


export default function JobAppointmentModal(props: IProps) {

    const hub = useHub();
    const pref = usePreferences();
    const drawerRef = useRef<DrawerFormRef>(null);
    const [minToTime, minToTimeSet] = useState<number>();

    const [apFromTime, apFromTimeSet] = useState<TimeItem>();
    const [apToTime, apToTimeSet] = useState<TimeItem>();

    const [selectedApptDate, selectedApptDateSet] = useState<Date>()

    const [statuses, statusesSet] = useState<JobStatus[]>([]);
    const [selectedStatus, selectedStatusSet] = useState<JobStatus>();

    const fetchStatuses = () => {
        hub.Get(API_ROUTES.JobStatuses + "forappointmentremove", res => {
            if (res.success && res.data) {
                statusesSet(res.data);
            }
        })
    }
    const fetchReminders = () => {
        hub.Get(API_ROUTES.Jobs + "getreminders/" + props.job.id, res => {
            if (res.success && res.data) {
                const itemsWithId: JobApptReminderItem[] = res.data.map((item: JobApptReminderItem, i: number) => ({
                    ...item,
                    id: i + 1
                }));
                remindersSet(itemsWithId);
                const maxId = Math.max(...itemsWithId.map(i => i.id ?? 0), 0);
                nextId.current = maxId + 1;
            }
        })
    }

    useEffect(() => {
        fetchStatuses();
        fetchReminders();
    }, [])

    useEffect(() => {
        if (props.job?.appointmentTimeFrom && props.job.appointmentTimeFrom.includes(":")) {
            var h = parseInt(props.job.appointmentTimeFrom.split(":")[0]);
            var m = parseInt(props.job.appointmentTimeFrom.split(":")[1]);
            var t = (h * 60) + m;
            minToTimeSet(t);
        }

        if (props.job.appointmentDate && props.job.appointmentFrom) {
            selectedApptDateSet(props.job.appointmentFrom);
        }

        if (!window.isNullOrEmpty(props.job.appointmentTimeTo)) apptTimeRangeSet(true)

    }, [props.job])


    const submit = (body: any, callback: any) => {

        window.hideFormErrors();
        var valid = true;

        if (window.isNullOrEmpty(body.appointmentDate)) {
            window.showFormError("appointmentDate", "select appointment date!", true, "drawer-update-appoiontment", true);
            valid = false;
        }

        if (!apFromTime) {
            window.showFormError("appointmentFromText", "select arrival from time!", true, "drawer-update-appoiontment", true);
            valid = false;
        }

        if ((apptTimeRange || pref?.jobsPreferences.forceTimeRangeForAppt) && !apToTime) {
            window.showFormError("appointmentToText", "select arrival to time!", true, "drawer-update-appoiontment", true);
            valid = false;
        }

        // if (apFromTime && apToTime && apToTime.time <= apFromTime.time && !apToTime.nextDay) {
        //     window.showFormError("appointmentToText", "must be greater than arrival from time!", true, "drawer-update-appoiontment", true);
        //     valid = false;
        // }


        reminders.forEach(r => {
            if (r.type == 1 || r.type == 2) {
                if ((r.amount ?? 0) < 1) {
                    window.formError(`reminder-amount-${r.id}`, "", "drawer-update-appoiontment");
                    valid = false;
                }
            }
            if (r.type == 3) {
                if (!r.date || moment(r.date).year() < moment().year()) {
                    window.formError(`reminder-date-${r.id}`, "", "drawer-update-appoiontment");
                    valid = false;
                }
            }
        });

        if (!valid) {
            if (callback) callback();
            return;
        }

        if (reminders.length == 0 && body.remindersConfirm != "true") {
            if (callback) callback();
            window.openModal("modal-noapptreminder-confirm");
            return;
        }

        let b = {
            ...body,
            id: props.job?.id,
            remindersCount: reminders.length
        };

        for (var r = 0; r < reminders.length; r++) {
            b[`reminderType${r}`] = reminders[r].type;
            if (reminders[r].type == 3) b[`reminderDate${r}`] = reminders[r].date;
            else b[`reminderAmount${r}`] = reminders[r].amount;
            b[`reminderAction${r}`] = reminders[r].action;
        }

        hub.Post(API_ROUTES.Jobs + "appoiontment", b, res => {
            if (props.onUpdate) props.onUpdate();
            if (callback) callback(res);
        });

    }

    const nextId = useRef<number>(1);
    const [reminders, remindersSet] = useState<JobApptReminderItem[]>([]);

    const [apptTimeRange, apptTimeRangeSet] = useState<boolean>(false)

    return (
        <>
            <DrawerForm ref={drawerRef} id="drawer-update-appoiontment"
                title="Appointment" size="medium"
                subtitle={"Job ID: #" + props.job?.jobId + " | " + props.job?.fullName}
                buttonText="Set Appointment"
                onClose={props.onClose}
                onSubmit={submit}>
                {
                    false ?
                        <div className="alert alert-danger">
                            You must assign a technician to the job first!
                        </div>
                        :
                        <div>
                            <FlexRow>
                                <label className={"flex-grow-1 fs-7 mb-1"} htmlFor={"dt-jobupdateappoitment"}>
                                    Appointment Date
                                    {
                                        <span id={"appointmentDate-err"} className="small text-danger mx-3 form-error"></span>
                                    }
                                </label>
                                {
                                    props.job?.appointmentDate &&
                                    <a href="#" className="fs-8 text-danger"
                                        onClick={e => {
                                            e.preventDefault();
                                            window.openModal("modal-clear-appointment-confirm");
                                        }}>Remove Appointment</a>
                                }
                            </FlexRow>

                            {/* <div>
                                {props.job?.appointmentFrom} - {props.job?.timezoneOffset}
                            </div>

                            <div>
                                {moment(props.job?.appointmentFrom)?.toString()}
                            </div>
                            <div>
                                {moment(props.job?.appointmentFrom)?.utc().toString()}
                            </div>
                            <div>
                                {toJobDate(props.job?.appointmentFrom, props.job?.timezoneOffset)?.toString()}
                            </div> */}

                            {/* date={toJobDate(props.job?.appointmentFrom, props.job?.timezoneOffset)} */}

                            <DatePicker id="dt-jobupdateappoitment" name="appointmentDate" icon="calendar-clock"
                                block empty date={props.job.appointmentFrom} dateOffset={props.job.timezoneOffset}
                                onPick={e => {
                                    window.hideFormErrors();
                                    selectedApptDateSet(e.date.toDate());
                                    var a = 1;
                                }} />

                            <div className="row">

                                <div className="col-12">
                                    <FlexRow>
                                        <div className="w-150px">
                                            <TimePicker key="job-appointmentmodal-from" id="job-appointmentmodal-from" name="appointmentFrom"
                                                value={props.job?.appointmentTimeFrom} noMarginBottom
                                                placeholder={`Arrival${((apptTimeRange || pref?.jobsPreferences.forceTimeRangeForAppt) ? " From" : "")}`}
                                                onTimePicked={t => {
                                                    window.hideFormErrors();
                                                    minToTimeSet(t.time);
                                                    apFromTimeSet(t);
                                                }}
                                                onTimeCleared={() => apFromTimeSet(undefined)}
                                            />
                                        </div>

                                        {
                                            !pref?.jobsPreferences.forceTimeRangeForAppt &&
                                            <>
                                                {
                                                    apptTimeRange ?
                                                        <div className="ms-2">
                                                            <button type="button" className="btn btn-primary btn-icon btn-sm"
                                                                onClick={e => apptTimeRangeSet(false)}>
                                                                <Icon icon="chevron-right" size={16} />
                                                            </button>
                                                        </div>
                                                        :
                                                        <div className="ms-2">
                                                            <button type="button" className="btn btn-light btn-icon btn-sm"
                                                                onClick={e => apptTimeRangeSet(true)}>
                                                                <Icon icon="chevron-right" size={16} />
                                                            </button>
                                                        </div>
                                                }
                                            </>
                                        }

                                        {
                                            (pref?.jobsPreferences.forceTimeRangeForAppt || apptTimeRange) &&
                                            <div className="w-150px ms-2">
                                                <TimePicker id="job-appointmentmodal-to" name="appointmentTo" noMarginBottom
                                                    min={minToTime} placeholder="Arrival To"
                                                    time={minToTime ? (minToTime + ((pref?.jobsPreferences.defaultTimeRangeForAppt ?? 1) * 60)) : undefined}
                                                    onTimePicked={t => {
                                                        window.hideFormErrors();
                                                        apToTimeSet(t);
                                                    }}
                                                    onTimeCleared={() => apToTimeSet(undefined)}
                                                    value={props.job.appointmentTimeTo} />
                                            </div>

                                        }

                                    </FlexRow>
                                </div>
                            </div>

                            {
                                props.forceUpdateStatus ?
                                    <input type="hidden" name="updateStatus" value="True" />
                                    :
                                    <div className="mt-3">
                                        <ToggleSwitch name="updateStatus" label="Update Job Status to Appointment" raw small checked />
                                        {/* <div className="form-check form-check-custom form-check-solid form-check-sm">
                                        <input className="form-check-input" type="checkbox" name="updateStatus" value="True" defaultChecked id="chk-appointment-update-status" />
                                        <label className="form-check-label fs-7" htmlFor="chk-appointment-update-status">
                                            Update Job Status to Appointment
                                        </label>
                                    </div> */}
                                    </div>
                            }

                            <hr />

                            <input type="hidden" name="remindersConfirm" id="hidden-remindersConfirm" value="false" />

                            {
                                reminders.map(r =>
                                    <FlexRow key={`reminder-item-${r.id}`} className="mb-4">
                                        <button className="btn btn-sm btn-light-danger btn-icon me-2"
                                            onClick={e => {
                                                e.preventDefault();
                                                remindersSet(prev => prev.filter(f => f.id != r.id))
                                            }}>
                                            <Icon icon="minus" />
                                        </button>
                                        <div className="me-2" style={{ width: 120 }}>
                                            <select key={`reminder-type-${r.id}`} className="form-select form-select-sm"
                                                value={r.type} onChange={e => {
                                                    var t = Number.parseInt(e.target.value);
                                                    remindersSet(p =>
                                                        p.map(f => f.id == r.id ? { ...f, type: t } : f)
                                                    )
                                                }}>
                                                <option value={1}>Minutes</option>
                                                <option value={2}>Hours</option>
                                                <option value={3}>Custom</option>
                                            </select>
                                        </div>
                                        {
                                            r.type == 3 ?
                                                <div className="me-2" style={{ width: 200 }}>
                                                    <DatePicker key={`reminder-datepicker-${r.id}`} id={`reminder-datepicker-${r.id}`} name={`reminder-date-${r.id}`}
                                                        preventClear noTextError
                                                        //minDate={moment().utc().add(props.job.timezoneOffset ?? 0, "minutes").toDate()}
                                                        maxDate={selectedApptDate}
                                                        timePicker block marginBottom={0} small icon="calendar-clock" selectedDate={r.date}
                                                        onPick={e => {
                                                            remindersSet(p =>
                                                                p.map(f => f.id == r.id ? {
                                                                    ...f,
                                                                    date: e.value
                                                                } : f)
                                                            )
                                                        }} />
                                                </div>
                                                :
                                                <div className="me-2" style={{ width: 200 }}>
                                                    <TextBox key={`reminder-amount-${r.id}`} name={`reminder-amount-${r.id}`}
                                                        block noMarginBottom value={r.amount} numeric maxLength={3} labelUp noTextError
                                                        small iconText={r.type == 1 ? "Minutes Before" : "Hours Before"}
                                                        onTextChanges={txt => {
                                                            remindersSet(p =>
                                                                p.map(f => f.id == r.id ? { ...f, amount: isNaN(Number.parseInt(txt)) ? 0 : Number.parseInt(txt) } : f)
                                                            )
                                                        }} />
                                                </div>
                                        }

                                        <div className="flex-grow-1">
                                            <select key={`reminder-action-${r.id}`} className="form-select form-select-sm"
                                                value={r.action} onChange={e => {
                                                    var t = Number.parseInt(e.target.value);
                                                    remindersSet(p =>
                                                        p.map(f => f.id == r.id ? { ...f, action: t } : f)
                                                    )
                                                }}>
                                                <option value={1}>Move to Top & Send to Technician</option>
                                                <option value={2}>Move to Top</option>
                                                <option value={3}>Send to Technician</option>
                                            </select>
                                        </div>

                                    </FlexRow>
                                )
                            }



                            <button className="btn btn-sm btn-outline btn-outline-dashed btn-outline-secondary btn-active-light-secondary text-muted"
                                onClick={e => {
                                    e.preventDefault();
                                    remindersSet(p => [...p, {
                                        id: nextId.current++,
                                        type: 1,
                                        amount: 60,
                                        action: 1
                                    }])
                                }}>
                                <Icon icon="plus" />
                                Add Reminder
                            </button>

                            {/* <div className="mt-5 mb-5">
                                <ToggleSwitch name="appointmentReminder" label="Send Reminder to Technician"
                                    raw small checked={appointmentReminder}
                                    onChange={e => appointmentReminderSet(e)} />
                            </div>

                            {
                                appointmentReminder &&
                                <TextBox name="appointmentReminderTime" block
                                    numeric maxLength={3} iconText="Minutes Before"
                                    value={(props.job?.appointmentReminderTime ?? 60)} />
                            } */}

                        </div>
                }

            </DrawerForm>

            <Modal id="modal-clear-appointment-confirm"
                title="Remove Appointment"
                secondModal
                onSubmit={(body, callback) => {

                    if (props.job?.isAppointment) {
                        if (selectedStatus?.noteRequired && (!body.statusNote || body.statusNote.length < 3)) {
                            window.showFormError("statusNote", "Please write the status note!", false, "modal-clear-appointment-confirm");
                            if (callback) callback();
                            return;
                        }
                    }

                    hub.Post(API_ROUTES.Jobs + "clearappoiontment", {
                        ...body,
                        id: props.job?.id
                    }, res => {
                        if (res.success) {
                            window.closeModal("modal-clear-appointment-confirm");
                            drawerRef.current?.close();
                        }
                    });

                }}
                buttonText="Confirm & Remove"
                buttonColor="danger">
                {
                    props.job?.isAppointment ?
                        <div>
                            <p>Remove the appointment and update the job status to: </p>
                            <DropDown id="drp-clearapp-jobstatus" name="statusId"
                                source={statuses} autoSelectFirstItem block
                                onSelectItem={e => selectedStatusSet(e)}></DropDown>

                            {
                                selectedStatus?.noteRequired &&
                                <TextArea name="statusNote" label="Status Note*" block labelUp
                                    placeholder={"Please describe why you're changing the status to " + selectedStatus.name} />
                            }
                        </div>
                        :
                        <div className="my-10">
                            Are you sure you want to remove the appointment?
                        </div>
                }

            </Modal>

            <Modal id="modal-noapptreminder-confirm"
                title="Alert"
                secondModal
                onConfirm={callback => {
                    document.getElementById("hidden-remindersConfirm")?.setAttribute("value", "true");
                    // Re-run the drawer's form submit (now that reminders are confirmed).
                    // DrawerForm wraps children in a <form id={`${id}-form`}>.
                    const form = document.getElementById("drawer-update-appoiontment-form") as HTMLFormElement | null;
                    form?.requestSubmit();
                    callback();
                }}
                buttonText="Confirm & Update"
                buttonColor="warning">

                <div className="my-10">
                    You haven't added any reminders for this appointment. If you continue, the reminder will be sent based on the technician's default settings. Are you sure you want to proceed?
                </div>

            </Modal>
        </>
    )

}